export default __webpack_public_path__ + "static/media/VehicleInfo.1c73d259.png";